import type { Prototype } from "../prototype-types";

export const matthewBojeyPrototypes: Prototype[] = [
  {
    id: "mb-quick-view-inline-expansion",
    name: "Quick View — Inline Row Expansion",
    path: "/mb/quick-view-inline-expansion",
    description:
      "The reclaimed-corner trigger expands a product into a full-width detail row without covering or resizing the search grid.",
    owner: "Matthew Bojey",
    createdAt: "2026-09-02",
    lastUpdated: "2026-09-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.faire.com/fastly/061c0a70ce642e2c62b0c3316820c29c8366e085a17334d9e0e141fe8fffc5c0.jpeg?bg-color=FFFFFF&fit=crop&format=jpg&height=720&width=720",
  },
];
